﻿import * as popupTemplateCreator from "@arcgis/core/smartMapping/popup/templates.js";
import * as clusterPopupTemplateCreator from "@arcgis/core/smartMapping/popup/clusters.js";
import {arcGisObjectRefs} from "./arcGisJsInterop";
import {buildJsRenderer} from "./jsBuilder";
import {buildDotNetPopupTemplate} from "./dotNetBuilder";

export default class PopupTemplateCreatorWrapper {
    private dotNetRef: any;
    
    constructor(dotNetRef) {
        this.dotNetRef = dotNetRef;
    }

    async getTemplates(params: any): Promise<any> {
        try {
            let results = await popupTemplateCreator.getTemplates({
                layer: arcGisObjectRefs[params.layer.id] as any,
                renderer: buildJsRenderer(params.renderer) ?? undefined
            });
            return {
                primaryTemplate: this.buildTemplateResult(results.primaryTemplate),
                secondaryTemplates: results.secondaryTemplates?.map(this.buildTemplateResult)
            }
        } catch (error) {
            console.error(error);
            throw error;
        }
    }
    
    buildTemplateResult(result: __esri.Template): any {
        return {
            name: result.name,
            title: result.title,
            value: buildDotNetPopupTemplate(result.value)
        }
    }

    async getClusterTemplates(params: any) {
        try {
            let results = await clusterPopupTemplateCreator.getTemplates({
                layer: arcGisObjectRefs[params.layer.id] as any,
                renderer: buildJsRenderer(params.renderer) ?? undefined
            });
            return {
                primaryTemplate: this.buildTemplateResult(results.primaryTemplate),
                secondaryTemplates: results.secondaryTemplates?.map(this.buildTemplateResult)
            }
        } catch (error) {
            console.error(error);
            throw error;
        }
    }
}